import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  dashboardJefe: [],
  dashboardJefeError: "",
};

export default function DashboardJefeReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_DASHBOARD_JEFE:
      return { ...state, loading: action.payload };
    case actions.GET_DASHBOARD_JEFE:
      return { ...state, dashboardJefe: action.payload };
    case actions.DASHBOARD_JEFE_FAIL:
      return { ...state, dashboardJefeError: action.payload };
    default:
      return state;
  }
}
